$('.select2:not([data-tags=true])').select2();
$('.select2[data-tags=true]').select2({tags: true});
